<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.working_hours">
  <div class="row" *ngIf="isHeaderRequired && header != ''">
    <div class="col-md-12">
      <app-label [Text]="header" [IsNeedNewLine]="IsNeedNewLine" [IsMandatory]="IsMandatory"></app-label>
    </div>
  </div>
  <div>
    <div style="margin-left:5px;" *ngIf="selectedRange">
      <div class="row">
        <div class="col-md-12">
          <label style="font-weight: normal; margin-left: 30px;" [ngStyle]="{'opacity' : isReadOnly ? '0.9' : '1'}">
            <input type="checkbox" [(ngModel)]="isAnyTime" [disabled]="isReadOnly" (change)="onEmitValue()" />
            <span class="normal_color">{{localService.languageContent.working_hours.any_time}}</span>
          </label>
        </div>
      </div>
      <div [ngStyle]="{'opacity' : isAnyTime || isReadOnly ? '0.9' : '1'}">
        <div class="row" *ngIf="isOnlyTime">
          <div class="col-md-6">
            <app-time-picker [isHorizontal]="false" [isDisabled]="isAnyTime || isReadOnly"
              [selectedTime]="selectedRange.v3" (onTimeUpdated)="onTimeUpdate($event,true)"></app-time-picker>
          </div>
          <div class="col-md-6">
            <app-time-picker [isHorizontal]="false" [isDisabled]="isAnyTime || isReadOnly"
              [selectedTime]="selectedRange.v5" (onTimeUpdated)="onTimeUpdate($event,false)"></app-time-picker>
          </div>
        </div>
        <div *ngIf="!isOnlyTime">
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-md-6" style="text-align:right;" *ngIf="config != null">
              <app-date-picker [isDisabled]="isAnyTime || isReadOnly" [selectedDate]="selectedRange.v2"
                (selectedDateChange)="selectedRange.v2 = $event;onEmitValue();"></app-date-picker>
            </div>
            <div class="col-md-6">
              <app-time-picker [isDisabled]="isAnyTime || isReadOnly" [selectedTime]="selectedRange.v3"
                (onTimeUpdated)="onTimeUpdate($event,true)"></app-time-picker>
            </div>
          </div>
          <div class="row" style="margin-bottom: 10px;" *ngIf="isShowToRange">
            <div class="col-md-6" style="text-align:right;" *ngIf="config != null">
              <app-date-picker [isDisabled]="isAnyTime || isReadOnly" [selectedDate]="selectedRange.v4"
                (selectedDateChange)="selectedRange.v4 = $event;onEmitValue();"></app-date-picker>
            </div>
            <div class="col-md-6">
              <app-time-picker [isDisabled]="isAnyTime || isReadOnly" [selectedTime]="selectedRange.v5"
                (onTimeUpdated)="onTimeUpdate($event,false)"></app-time-picker>
            </div>
          </div>
        </div>
        <div *ngIf="isShowWeekDays" style="margin-top: 10px;" class="box">
          <div *ngFor="let item of weekDays; index as i">
            <div class="row" *ngIf="i == 0 || i == 2 || i == 4|| i == 6">
              <div class="col-md-6">
                <label style="font-weight: normal; margin-left: 30px;">
                  <input type="checkbox" [disabled]="isAnyTime || isReadOnly" value="{{weekDays[i].key}}"
                    [(ngModel)]="weekDays[i].isSelected" (change)="onEmitValue()" />
                  <span class="normal_color">{{weekDays[i].value}}</span>
                </label>
              </div>
              <div class="col-md-6" *ngIf="i != 6">
                <label style="font-weight: normal; margin-left: 30px;">
                  <input type="checkbox" [disabled]="isAnyTime || isReadOnly" value="{{weekDays[i + 1].key}}"
                    [(ngModel)]="weekDays[i + 1].isSelected" (change)="onEmitValue()" />
                  <span class="normal_color">{{weekDays[i + 1].value}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>